export const RoleEnum = {
  ADMIN: 1,
  USER: 2,
  DELEGATE: 3,
  SUPERVISOR: 6,
};